import { Component } from '@angular/core';

@Component({
  selector: 'mprd-nsp-activation-skeleton',
  templateUrl: './nsp-activation-skeleton.component.html',
})
export class NspActivationSkeletonComponent {
  constructor() {}
}
